export const CHIPS_INITIAL_DATA = [
  { label: "Publishing Consulting", selected: true },
  { label: "Editing and Proofreading", selected: false },
  { label: "Graphic Design", selected: false },
  { label: "Desktop Publishing", selected: false },
  { label: "Amazon CreateSpace and Kindle Publishing", selected: false },
  { label: "Distribution Consultation", selected: false },
  { label: "Marketing", selected: false },
];
